
const getDecorationTypeLv1List = (decorationTypeList) => {
    let filteredList = decorationTypeList.filter(item => {
        return item.id.toString().startsWith('1');
    });
    return filteredList;
}

const getDecorationTypeLv2List = (decorationTypeList) => {
    let filteredList = decorationTypeList.filter(item => {
        return item.id.toString().startsWith('2');
    });
    return filteredList;
}

const getDecorationTypeLv3List = (decorationTypeList) => {
    let filteredList = decorationTypeList.filter(item => {
        return item.id.toString().startsWith('3');
    });
    return filteredList;
}

const getDecorationTypeLv4List = (decorationTypeList) => {
    let filteredList = decorationTypeList.filter(item => {
        return item.id.toString().startsWith('4');
    });
    return filteredList;
}

const getDecorationTypeLv5List = (decorationTypeList) => {
    let filteredList = decorationTypeList.filter(item => {
        return item.id.toString().startsWith('5');
    });
    return filteredList;
}

const getDecorationTypeLv6List = (decorationTypeList) => {
    let filteredList = decorationTypeList.filter(item => {
        return item.id.toString().startsWith('6');
    });
    return filteredList;
}

const getDecorationTypesMap = (decorationTypeList) => {
    let map = [
        getDecorationTypeLv1List(decorationTypeList),
        getDecorationTypeLv2List(decorationTypeList),
        getDecorationTypeLv3List(decorationTypeList),
        getDecorationTypeLv4List(decorationTypeList),
        getDecorationTypeLv5List(decorationTypeList),
        getDecorationTypeLv6List(decorationTypeList),
    ]
    return map;
}

const getDecorationTypeFilteredList = (decorationTypeList, searchPhrase) => {
    var searchSuggestionList = [];
    decorationTypeList.forEach((item) => {
        if (item.searchLabel.toLowerCase().includes(searchPhrase.toLowerCase())) {
            searchSuggestionList.push(item)
        }
    })
    return searchSuggestionList;
}

const getDecorationLowList = (decorationList) => {
    var lowWidth;
    var lowHeight;
    const mappedList = decorationList.map(item => {
        if (item.width === 1280) {
            lowWidth = 320
        } else if (item.width === 720) {
            lowWidth = 180
        }
        if (item.height === 1280) {
            lowHeight = 320
        } else if (item.height === 720) {
            lowHeight = 180
        }
        return { ...item, width: lowWidth, height: lowHeight };
    })
    return mappedList
}

const getBirthOptionList = (decorationTypeList) => {
    const birthId = 100001;
    let filteredList = [];
    decorationTypeList.forEach((item) => {
        if (item.id === birthId) {
            filteredList.push({ label: 'Todos los cumpleaños', value: item.id.toString() });
        }
        if (item.parentLv1Id === birthId) {
            filteredList.push({ label: item.title, value: item.id.toString() })
        }
    })
    return filteredList;
}


export {
    getDecorationTypeLv1List,
    getDecorationTypeLv2List,
    getDecorationTypeLv3List,
    getDecorationTypeLv4List,
    getDecorationTypeLv5List,
    getDecorationTypeLv6List,
    getDecorationTypesMap,
    getDecorationTypeFilteredList,
    getDecorationLowList,
    getBirthOptionList
}